import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Printer = function Printer(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18 7V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.4802 2 15.9201 2 14.8 2H9.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C6 3.5198 6 4.08 6 5.2V7m0 11c-.93 0-1.395 0-1.7765-.1022a3 3 0 0 1-2.1213-2.1213C2 15.395 2 14.93 2 14v-2.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 7 5.1198 7 6.8 7h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8V14c0 .93 0 1.395-.1022 1.7765a3 3 0 0 1-2.1213 2.1213C19.395 18 18.93 18 18 18m-3-7.5h3M9.2 22h5.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C18 20.4802 18 19.9201 18 18.8v-1.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.4802 14 15.9201 14 14.8 14H9.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C6 15.5198 6 16.0799 6 17.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C7.5198 22 8.08 22 9.2 22"
    })
  }));
};
export default Printer;